import { isAfter, isBefore, parseJSON } from 'date-fns';
import isEqual from 'lodash/isEqual';

type Tag<T> = { _tag: T };
export type IsoDateString = (string & Tag<'IsoDateString'>) | Tag<'IsoDateString'>;

export function createIsoDateString(str: string): IsoDateString {
    return str as IsoDateString;
}

export function toIsoDateString(date: Date): IsoDateString {
    return date.toISOString() as IsoDateString;
}

export function fromIsoDateString(stringOrDate: IsoDateString): Date {
    return parseJSON(stringOrDate as string);
}

export function fromIsoDateStringOrDate(stringOrDate: IsoDateString | Date): Date {
    if (stringOrDate instanceof Date) {
        return stringOrDate;
    } else {
        return fromIsoDateString(stringOrDate);
    }
}

export function isAfterOrEqual(
    leftDate: Date | IsoDateString,
    rightDate: Date | IsoDateString,
): boolean {
    const [l, r] = [
        fromIsoDateStringOrDate(leftDate),
        fromIsoDateStringOrDate(rightDate),
    ];
    return isAfter(l, r) || isEqual(l, r);
}

export function isBeforeOrEqual(
    leftDate: Date | IsoDateString,
    rightDate: Date | IsoDateString,
): boolean {
    const [l, r] = [
        fromIsoDateStringOrDate(leftDate),
        fromIsoDateStringOrDate(rightDate),
    ];
    return isBefore(l, r) || isEqual(l, r);
}
